<!--
 * @Author: qixiao
 * @Date: 2022-09-06 17:24:16
 * @LastEditTime: 2022-09-07 09:25:25
 * @LastEditors: qixiao
-->
<template>
	<el-main>
		<div class="top-wrap">
			<Bread></Bread>
			<div>
				<el-form :inline="true" :model="formInline" class="demo-form-inline">
					<el-form-item>
						<el-input v-model="formInline.productsName" placeholder="商品名称" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-cascader clearable placeholder="请选择商品分类" ref="elCascader" v-model="cascaderValue"
							:options="options" :show-all-levels="false"
							:props="{ value: 'id',label: 'name',children: 'szEnterpriseInfoList' ,checkStrictly: true}"
							@change="handleChange"></el-cascader>
					</el-form-item>
					<el-form-item>
						<el-select v-model="formInline.brandId" placeholder="选择品牌" clearable>
							<el-option v-for="item in szProductsBrandList" :label="item.brandName"
								:value="item.id.toString()"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="formInline.supplierId" placeholder="选择供应商" ref="supplierRef" clearable>
							<el-option v-for="item in szEnterpriseInfoList" :label="item.enterpriseName"
								:value="item.id.toString()"></el-option>
						</el-select>

					</el-form-item>
					<el-form-item>
						<el-select v-model="formInline.modeOfSupply" placeholder="供货方式" clearable>
							<el-option label="现货" value="10"></el-option>
							<el-option label="非现货" value="20"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">查询</el-button>
						<el-button type="primary" plain icon="el-icon-refresh-right" @click="handleReset('filterForm')">
							清空</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="main">
			<div class="tabs">
				<div @click="allProduct(item,index)" :class=" flag == index ? 'actives_flag' : '' "
					v-for="(item ,index) in tabList">
					<p class="ps1">{{item.name}}</p>
					<p class="ps2">{{item.val}}</p>
				</div>
			</div>
			<el-table :data="tableData" style="width: 100%; margin-top: 10px">
				<el-table-column label="序号" width="80" align="center">
					<template slot-scope="scope">
						{{ (pagination.currentPage - 1) * pagination.pageSize + (scope.$index + 1) }}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="商品图片" min-width="8%" align="center">
					<template slot-scope="{row}">
						<div>
							<el-image style="width: 50px; height: 50px;" :src="row.mainImgUrl"></el-image>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="productsName" label="商品名称" min-width="8%" align="center"></el-table-column>
				<el-table-column prop="class" label="分类" min-width="14%" align="center">
					<template slot-scope="{row}">
						<span v-if="row.oneClassName">{{row.oneClassName }} </span>
						<span v-if="row.twoClassName">/{{row.twoClassName }}</span>
						<span v-if="row.threeClassName">/{{row.threeClassName}} </span>
					</template>
				</el-table-column>
				<el-table-column prop="brandName" label="品牌" min-width="8%" align="center"></el-table-column>
				<el-table-column prop="supplierName" label="供应商" min-width="8%" align="center"></el-table-column>
				<el-table-column prop="modeOfSupply" label="供货方式" min-width="8%" align="center">
					<template slot-scope="{row}">
						{{row.modeOfSupply == 10 ? '现货' : '非现货'}}
					</template>
				</el-table-column>
				<el-table-column prop="topCli" label="上架" min-width="8%" align="center">
					<template slot-scope="{row}">
						<el-switch @change="uptStatusHandle(row)" v-model="row.status" active-color="#018388"
							inactive-color="#ccc">
						</el-switch>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="solt" label="排序" min-width="8%" align="center"></el-table-column> -->
				<el-table-column label="操作" min-width="8%" align="center">
					<template slot-scope="{ row }">
						<el-button type="primary" plain round size="small" @click="amend(row)">修改</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="total,prev, pager, next,jumper" :page-size="pagination.pageSize"
				:total="pagination.recordTotal" :hide-on-single-page="true" @current-change="handleCurrentChange"
				:current-page.sync="pagination.currentPage">
			</el-pagination>

		</div>
	</el-main>
</template>
<script>
// import skuList from "./skuList";
import { query } from 'quill';
import treeComp from './tree';
export default {
	components: {
		treeComp,
	},
	props: [],
	data() {
		return {
			flag: 0,
			tabList: [{
				name: "全部商品",
				id: 0,
				val: 0,
			}, {
				name: "已上架",
				id: 10,
				val: 0,
			}, {
				name: "未上架",
				id: 20,
				val: 0,
			}],
			cascaderValue: "",
			// 搜索部分

			formInline: {
				productsName: '', //商品名称
				class: '', //商品分类
				brandId: '', //品牌
				supplierId: '',//供应商
				status: '',//供货方式
				threeClassId: "",
				twoClassId: "",
				oneClassId: "",
				modeOfSupply: "",
			},
			//tab栏部分
			flag: 0, //active默认
			allNums: 0,//全部商品
			trueCli: 0,//已上架
			falseCli: 0,//未上架
			//表格部分
			tableData: [],

			//分页部分
			pagination: {
				currentPage: 1,
				pageSize: 10,
				recordTotal: 5,
			},
			options: [],
			szEnterpriseInfoList: [],//供应商列表
			szProductsBrandList: [],//品牌列表
		};
	},

	mounted() {
		this.commodityList();
		this.classList();
		this.enterpriseInfoListData();
		this.brandNameListData();
	},
	methods: {
		brandNameListData() {
			var parsms = {
				pageNum: 1,
				pageSize: 999
			}
			this.$http.orders.brandNameList(parsms).then((res) => {
				this.szProductsBrandList = res.data.szProductsBrandList;


			});
		},
		enterpriseInfoListData() {
			var parsms = {
				pageNum: 1,
				pageSize: 999
			}

			this.$http.orders.enterpriseInfoList(parsms).then((res) => {
				this.szEnterpriseInfoList = res.data.szEnterpriseInfoList;

			});
		},
		handleChange(val) {
			console.log(val)
			if (val && val.length > 0) {
				this.formInline.oneClassId = val[0];
				this.formInline.twoClassId = val[1];
				this.formInline.threeClassId = val[2];
			}


		},
		classList() {
			this.$http.orders.classList().then((res) => {
				this.options = res.data;
				var arr = this.options;
				this.findChild(arr)


			});
		},

		findChild(array) {
			for (let i in array) {
				var data = array[i];
				if (data.szEnterpriseInfoList) {
					this.findChild(data.szEnterpriseInfoList)
					data.id = data.id.toString();
				} else {
					data.id = data.id.toString();

				}
			}
		},

		//商品列表
		commodityList() {
			var params = {
				pageNum: this.pagination.currentPage,
				pageSize: this.pagination.pageSize,
				status: this.formInline.status,
				productsName: this.formInline.productsName,
				modeOfSupply: this.formInline.modeOfSupply,
				threeClassId: this.formInline.threeClassId,
				twoClassId: this.formInline.twoClassId,
				oneClassId: this.formInline.oneClassId,
				brandId: this.formInline.brandId, //品牌
				supplierId: this.formInline.supplierId,//供应商
			}
			this.$http.orders.commodityList(params).then((res) => {
				console.log(res)
				this.tableData = res.data.szProductsSpuList;
				this.pagination.recordTotal = res.data.count;
				this.allNums = res.data.count;
				this.trueCli = res.data.upperShelf;
				this.falseCli = res.data.lowerShelf;
				this.tabList[0].val = Number(res.data.upperShelf + res.data.lowerShelf);
				this.tabList[1].val = res.data.upperShelf;
				this.tabList[2].val = res.data.lowerShelf;

				for (var i = 0; i < this.tableData.length; i++) {
					if (this.tableData[i].status == 10) {
						this.tableData[i].status = true;
					} else {
						this.tableData[i].status = false;
					}
				}

			});
		},
		uptStatusHandle(val) {
			console.log(val)
			var params = {
				id: val.id.toString(),
				status: val.status ? 10 : 20,
			}
			this.$http.orders.uptStatus(params).then((res) => {
				console.log(res)
				if (res.status == 1) {
					this.$message.success("修改成功");
					this.commodityList();
				}
			});

		},
		handleCurrentChange(val) {
			//分页
			this.pagination.currentPage = val;
			this.commodityList();
		},

		//查询

		onSubmit() {
			console.log(this.formInline)
			this.commodityList();
		},

		//清空

		handleReset() {
			this.formInline = {
				productsName: '', //商品名称
				class: '', //商品分类
				brandId: '', //品牌
				supplierId: '',//供应商
				status: '',//供货方式
				threeClassId: "",
				twoClassId: "",
				oneClassId: "",
				modeOfSupply: "",
			}

		},

		//查看操作

		lookDetail(val) {
			this.$router.push('./EnterDetail')
		},

		//修改操作

		amend(val) {
			console.log(val);
			this.$router.push({ path: './GoodsAmend', query: { ids: val.id } })
		},

		//全部商品

		allProduct(item, index) {
			this.flag = index;
			this.pagination.currentPage = 1
			if (index == 0) {
				this.formInline.status = '';
			} else {
				this.formInline.status = item.id;
			}

			this.commodityList();

		}
	},
};
</script>
<style lang="scss">
.actives_flag {
	background-color: #06959C !important;

}

.actives_flag p {
	color: #fff;
}

.ps1 {
	height: 17px;
	font-size: 16px;
	font-weight: 400;
	color: #666666;
}

.ps2 {
	height: 22px;
	font-size: 28px;
	font-weight: bold;
	color: #323333;
}
</style>
<style lang='scss' scoped>
.tabs {
	div {
		box-sizing: border-box;
		padding-top: 6px;
		display: inline-block;
		width: 132px;
		height: 64px;
		border-radius: 6px;
		background: #F4F4F4;
		margin-right: 11px;
		text-align: center;
		cursor: pointer;
		margin-top: 10px;
		margin-bottom: 5px;
	}
}

::v-deep .el-image__error {
	font-size: 10px;
}

.el-upload {
	.icon-camera {
		width: 38px;
	}
}

.plate {
	.title-bor-left {
		margin-bottom: 15px;
	}

	.tip-txt {
		font-size: 16px;
		color: #cbcbcb;
	}

	.btn-addspec {
		font-size: 16px;
		padding: 11px;
	}

	.spec-list {
		border: 1px solid #E8E8E8;
		padding: 12px;
		margin-top: 10px;
		font-size: 16px;
		color: #323333;

		.spec-name {
			background: #F7F8FA;
			padding: 10px;
			position: relative;

			.el-input {
				width: 160px;
			}

			.icon-close {
				cursor: pointer;
				font-size: 28px;
				opacity: 0.5;
				position: absolute;
				right: 10px;
				top: 50%;
				transform: translateY(-50%);
			}
		}

		.spec-val {
			padding: 10px;

			.el-input {
				width: 160px;
				margin-right: 10px;
				margin-bottom: 10px;
			}
		}
	}

	.table-spec {
		// width: 100%;
		border: 1px solid #E8E8E8;

		thead {
			background: #F7F7F7;
			height: 54px;

			.star {
				color: #EE0000;
			}
		}

		th,
		td {
			font-size: 16px;
			color: #323333;
			font-weight: normal;
			text-align: center;
			width: 150px;
			box-sizing: border-box;
		}

		// .el-input{
		// 	width: 80%;
		// 	margin: 10px 0;
		// }
	}
}

.foot {
	width: calc(100% + 30px);
	margin-left: -15px;
	height: 96px;
	background: #ffffff;
	box-shadow: 0px -6px 8px rgba(0, 0, 0, 0.06);
	display: flex;
	align-items: center;
	justify-content: center;
	position: sticky;
	bottom: -15px;

	.el-button {
		font-size: 18px;
		padding: 17px 56px;

		&:nth-child(2n) {
			margin-left: 20px;
		}
	}
}

.table-tree {
	position: relative;

	&:before {
		content: "";
		height: 1px;
		background: #ffffff;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
	}

	&:after {
		content: "";
		width: 1px;
		background: #ffffff;
		position: absolute;
		right: 0;
		top: 0;
		bottom: 0;
	}
}
</style>
